
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxdebtoffers/[genericRoute]/[keyword]",
      function () {
        return require("private-next-pages/taxdebtoffers/[genericRoute]/[keyword].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taxdebtoffers/[genericRoute]/[keyword]"])
      });
    }
  